import type { AICustomizationResponse } from '~/api/ai'
import { LocalStorageService } from '~/services/storage'

/**
 * Lightweight, local-only AI prompt/response history for quick recall in the UI.
 * Stores a small recent window in `localStorage` and provides simple helpers.
 */

export interface AIHistoryItem {
  id: string
  prompt: string
  response: AICustomizationResponse
  timestamp: number
}

const HISTORY_KEY = 'joggo_ai_history'
const MAX_HISTORY_ITEMS = 5

const historyStorage = new LocalStorageService<AIHistoryItem[]>(HISTORY_KEY)

export function saveToHistory(
  prompt: string,
  response: AICustomizationResponse
): void {
  const history = getHistory()
  const newItem: AIHistoryItem = {
    id: Date.now().toString(),
    prompt,
    response,
    timestamp: Date.now()
  }

  const updatedHistory = [newItem, ...history].slice(0, MAX_HISTORY_ITEMS)
  historyStorage.set(updatedHistory)
}

export function getHistory(): AIHistoryItem[] {
  return historyStorage.get() || []
}

export function clearHistory(): void {
  historyStorage.clear()
}
